import React from 'react'
import * as UI from 'ui'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import CopyChecklistTemplateSmartview from 'pages/app/checklists/smartviews/CopyChecklistTemplateSmartview'
import { useModelKey } from '@morningtrain/react-resources'

export default function CopyChecklistTemplateButton () {

  const checklistTemplateId = useModelKey()

  return (
    <MountSmartviewOnClick smartview={<CopyChecklistTemplateSmartview id={checklistTemplateId}/>} replace={false}>
      <UI.SquareButton color="lightgray">
        <UI.Icons.Share/>
      </UI.SquareButton>
    </MountSmartviewOnClick>
  )
}
